import Brand from '^enums/Brand';
import ApplicationFeature from '^enums/ApplicationFeature';
import BusinessType from '^enums/BusinessType';

if (!window.xprops) {
  window.xprops = {
    brand: Brand.Peugeot,
    modelCode: 'NY_308_Plug-In_Hybrid',
    businessType: BusinessType.Retail,
    configuratorUrl: '',
    features: [
      ApplicationFeature.CampaignVariantsSection,
      ApplicationFeature.VariantsSection,
      ApplicationFeature.TechnicalSpecificationsSection,
      ApplicationFeature.TrimEquipmentComparisonSection,
      ApplicationFeature.ColorsSection,
      ApplicationFeature.DownloadPdf,
      ApplicationFeature.ShowWidgetImage,
      ApplicationFeature.IsFirstColumnExpanded,
      ApplicationFeature.ChargingSubscriptionsSection,
      ApplicationFeature.InteriorsSection,
    ],
    selector: '',
    fixedElementsSelectors: [],
    isWidgetMode: false,
    parentUrl: window.location.href,
    autoCalculateSpacers: (): Promise<undefined> => Promise.resolve(undefined),
    scrollTo: async (options: ScrollToOptions): Promise<void> => window.scrollTo({
      ...options,
      behavior: 'smooth',
    }),
    scrollToWidget: async (): Promise<void> => window.scrollTo({
      top: 0,
      behavior: 'smooth',
    }),
  };
}
